import { useEffect } from "react";
import { getDocFormsComlpleted, getDocFormsToAssign } from "../../../Services/docForm.service";
import useDocFormsStore from "../store/docFormsStore";

const normalizeInboxList = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    return [];
};

export const useAssignedForms = () => {
    const setLoading = useDocFormsStore((state) => state.setLoading);
    const assignedForms = useDocFormsStore((state) => state.assignedForms);
    const setAssignedForms = useDocFormsStore((state) => state.setAssignedForms);
    const completedForms = useDocFormsStore((state) => state.completedForms);
    const setCompletedForms = useDocFormsStore((state) => state.setCompletedForms);
    useEffect(() => {
        getAssignedForms();
    }, []);

    const getAssignedForms = async () => {
        setLoading(true);
        try {
            const response = await getDocFormsToAssign();
            setAssignedForms(normalizeInboxList(response));
        } catch (error) {
            console.error(error);
            setAssignedForms([]);
        } finally {
            setLoading(false);
        }
    }

    const getAssignedFormsFilteredByCompleted = async () => {
        try {
            const response = await getDocFormsComlpleted();
            setCompletedForms(normalizeInboxList(response));
        } catch (error) {
            console.error(error);
            setCompletedForms([]);
        }
    }

    return { assignedForms, getAssignedForms, getAssignedFormsFilteredByCompleted, completedForms };
};